// Feature flag for using mock data during development/testing
export const USE_MOCK_DATA = false;

// Mock data for testing - imported from sample-output.json
import mockBattleCardData from './sample-output.json';
export const MOCK_BATTLE_CARD_DATA = mockBattleCardData;

export const nodeIds = {
    TRIGGER: '8a1b2c3d-4e5f-6a7b-8c9d-0e1f2a3b4c5d',
    TRIGGER_N8N_WORKFLOW: '9b2c3d4e-5f6a-7b8c-9d0e-1f2a3b4c5d6e',
    WAIT_FOR_EXECUTION: 'a3d4e5f6-7a8b-9c0d-1e2f-3a4b5c6d7e8f',
    EXTRACT_OUTPUT_FIELDS: 'b4e5f6a7-8b9c-0d1e-2f3a-4b5c6d7e8f9a'
};

export const nodes = [
    {
        id: "trigger",
        display_name: "Manual Trigger",
        type: "workflow_module",
        action: "manual_trigger",
        credentials: [],
        description: "Initiates workflow on a manual trigger"
    },
    {
        id: "trigger_n8n_workflow",
        display_name: "Analyzing competitor website",
        type: "app_action",
        app: "n8n",
        action: "trigger_webhook",
        credentials: [],
        description: "Scanning positioning, messaging, and feature claims"
    },
    {
        id: "wait_for_execution",
        display_name: "Pulling review data",
        type: "app_action",
        app: "n8n",
        action: "wait_for_workflow_execution",
        credentials: [],
        description: "Collecting sentiment from G2, Capterra, and TrustRadius"
    },
    {
        id: "extract_output_fields",
        display_name: "Extracting pricing intel",
        type: "app_action",
        app: "sales_battle_card_generator",
        action: "extract_fields",
        credentials: [],
        description: "Identifying plans, packaging, and published rates"
    },
    {
        id: "mapping_feature_comparison",
        display_name: "Mapping feature comparison",
        type: "app_action",
        app: "sales_battle_card_generator",
        action: "extract_fields",
        credentials: [],
        description: "Matching their capabilities against atomicwork"
    },
    {
        id: "identifying_key_weaknesses",
        display_name: "Identifying key weaknesses",
        type: "app_action",
        app: "sales_battle_card_generator",
        action: "extract_fields",
        credentials: [],
        description: "Finding gaps and common customer complaints"
    },
    {
        id: "generating_objection_handlers",
        display_name: "Generating objection handlers",
        type: "app_action",
        app: "sales_battle_card_generator",
        action: "extract_fields",
        credentials: [],
        description: "Crafting responses to likely sales pushback"
    },
    {
        id: "building_win_narrative",
        display_name: "Building your win narrative",
        type: "app_action",
        app: "sales_battle_card_generator",
        action: "extract_fields",
        credentials: [],
        description: "Synthesizing differentiation and proof points"
    }
];

// Chat starter questions for the battle card agent
export const CHAT_STARTER_QUESTIONS = [
    {
        id: 1,
        text: "What's our key differentiator against this competitor?",
        icon: "Target"
    },
    {
        id: 2,
        text: "Where are they vulnerable, and what objections will I face?",
        icon: "Shield"
    },
    {
        id: 3,
        text: "What customer evidence proves we can win?",
        icon: "Award"
    },
    {
        id: 4,
        text: "How does pricing compare?",
        icon: "DollarSign"
    },
    {
        id: 5,
        text: "When do we win vs. walk away?",
        icon: "CheckCircle"
    }
];
